import React from "react";

import ModelportfolioList from "../../Modelportfolios/List"
import BaseDialog from "../../../components/BaseDialog/BaseDialog";
import PbButton from "../components/PbButton";
import {StartPortfolioBuilderButton} from "../../Modelportfolios/components/InstrumentsList/table-data";

const extraActionRender = (item) => <StartPortfolioBuilderButton item={item} onlyIcon={false} btnText={"Portfolio Builder"} iconPosition={'right'} />;


const MusterDepotSelectionModal = () => {

  const [open, setOpen] = React.useState(false);

  return (
    <>
      <PbButton text={'Musterdepot analysieren'} onClick={() => setOpen(true)} />
      <BaseDialog open={open} title={"Musterdepots"} handleClose={() => setOpen(false)}>
        <ModelportfolioList
          viewOnly
          hideDetailsBtn
          detailsInNewTab
          title={""}
          extraActionRender={extraActionRender}
          directAddingPossible={false}
        />
      </BaseDialog>
    </>
  )
};

export default MusterDepotSelectionModal;